'use strict';

var PooledSeasonalityInputDataViewport = function PooledSeasonalityInputDataViewport(ChartViewport, chartXAxis, chartGroups, chartSimpleBars, chartSimpleBarsOverlays, chartTiles) {
  var chartParams = require('./ParamsViewport');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters) {
    var groups = chartGroups('d1').asViewport();
    var m1Bar = chartSimpleBars('m1');
    var m2Bar = chartSimpleBars('m2');
    var overlay = chartSimpleBarsOverlays('o1');
    var tiles = chartTiles('d1', 'm2', 'tiles').withHeight(3);
    var xAxis = chartXAxis(formatters.xAxisViewportFormatter).withRepetition(1).withoutLine();
    ChartViewport.call(this, container, chartParams, chartScales, groups, m2Bar, m1Bar, tiles, overlay, xAxis);
  };
  Chart.prototype = Object.create(ChartViewport.prototype);
  Chart.constructor = Chart;
  return Chart;
};
PooledSeasonalityInputDataViewport.$inject = ['ChartViewport', 'ChartElementsXAxis', 'ChartElementsGroup', 'ChartElementsSimpleBars', 'ChartElementsSimpleBarsOverlays', 'ChartElementsTiles'];
module.exports = PooledSeasonalityInputDataViewport;